module.exports = __webpack_public_path__ + "static/media/junit.dcef2b90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/junit.png
// module id = 130
// module chunks = 0